<template>
  <div class="text-xs text-white/70 text-center" @click="present">Forgot Password?</div>
  <IonModal ref="modal">
    <IonHeader>
      <IonToolbar color="white">
        <IonTitle color="medium">Forgot Password?</IonTitle>
        <IonButtons slot="end">
          <IconButton @click="dismiss" icon="icon-x"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <div class="p-4 mb-6">
        <div class="text-gray-500 font-medium">We'll send you instructions to reset your password via email</div>
        <form @submit.prevent="submit()">
          <StackedTextInput
            title="Email"
            class="my-4"
            v-model="email.value"
            type="email"
            :errors="email.errors"
            :state="email.state"
            gray
          ></StackedTextInput>
          <PrimaryBlockButton :disabled="!email.valid || !email.value || sendingEmail" type="submit"
            >Send Reset Email</PrimaryBlockButton
          >
          <LightBlockButton class="mt-3" type="button" @click="dismiss">Close</LightBlockButton>
        </form>
      </div>
    </IonContent>
  </IonModal>
</template>

<script setup lang="ts">
import { IonModal, IonHeader, IonToolbar, IonTitle, IonButtons, IonContent } from '@ionic/vue';
import IconButton from '../forms/IconButton.vue';
import PrimaryBlockButton from '../forms/PrimaryBlockButton.vue';
import LightBlockButton from '../forms/LightBlockButton.vue';
import { ref } from 'vue';
import { UserService } from '@/http-services/user.service';
import { useToast } from '@/composables/use-toast';
import StackedTextInput from '../forms/stacked/StackedTextInput.vue';
import { useFormControl } from '@/composables/use-form-control';
import { EmailValidator } from '@/composables/validators/account-validators';

const modal = ref<InstanceType<typeof IonModal>>();
const userService = new UserService();
const toast = useToast();
const sendingEmail = ref(false);
const email = useFormControl(() => '', { validators: [EmailValidator()] });

function present() {
  email.value = '';
  modal.value?.$el.present();
}

function dismiss() {
  modal.value?.$el.dismiss();
}

function submit() {
  sendingEmail.value = true;
  userService
    .sendForgotPasswordEmail(email.value)
    .then((res: any) => {
      if (res.success) {
        toast.successToast(res.message, { duration: 3000 });
        email.value = '';
        dismiss();
      } else {
        toast.errorToast(res.message, { duration: 3000 });
      }
    })
    .catch(() => {
      toast.errorToast(`Error sending verification email to ${email.value}`, { duration: 3500 });
    })
    .finally(() => {
      sendingEmail.value = false;
    });
}
</script>
